// @flow
import React from 'react';
import {withRouter} from 'react-router';
import CategoryArchive from 'app/components/CategoryArchive';
import {MainLayout as Layout} from 'app/layouts/MainLayout';

class Category extends React.Component<Props> {
	render() {
		return (
			<Layout>
				<CategoryArchive
					categorySlug={this.props.match.params.category}
					page={this.props.match.params.page}
				/>
			</Layout>
		);
	}
}

const Component = withRouter(Category);
export {Component as Category};

export default Component;